module.exports = __webpack_public_path__ + "img/31.525f3756.png";